export default __webpack_public_path__ + "static/media/aws-logo.4172f10e.svg";